import * as api from "../Api";

export const monthStats = () => async (dispatch) => {
  try {
    const { data } = await api.monthStats();
    dispatch({ type: "MONTH_STATS", payload: data });
  } catch (error) {}
};
